module.exports = __webpack_public_path__ + "img/photo-23.674a7caf.jpg";